import clsx from 'clsx';
import { FC, memo, useMemo } from 'react';

import styles from './contact-item.module.scss';
import { IContactItemProps } from './types';

import { Paragraph } from '..';
import { AddressIcon, EmailIcon, PhoneIcon, TimeIcon, TelegramIcon, VKIcon } from '../icons';

const iconsMap = {
  address: AddressIcon,
  time: TimeIcon,
  phone: PhoneIcon,
  email: EmailIcon,
  telegram: TelegramIcon,
  vk: VKIcon,
};

export const ContactItem: FC<IContactItemProps> = memo(
  ({ text, icon, isPhone = false, isEmail = false, link, className = '', ...rest }) => {
    const CurrIcon = useMemo(() => iconsMap[icon], [icon]);

    const prefix = useMemo(() => (isEmail ? 'mailto' : isPhone ? 'tel' : ''), [isEmail, isPhone]);

    const handleClick = () => {
      if (link) window.open(link);
    };

    return (
      <li className={clsx(styles.container, className)} onClick={handleClick} {...rest}>
        <CurrIcon />
        {isPhone || isEmail ? (
          <a className={styles.link} href={`${prefix}:${isPhone || isEmail}`}>
            {text}
          </a>
        ) : (
          <Paragraph className={styles.text}>{text}</Paragraph>
        )}
      </li>
    );
  },
);
